import styled from 'styled-components';

export default styled.div`
  width: 180px;
  height: 1px;
  background-color: #b7b6cf;
`;
